import { useQuery } from "react-query";
import { getHeaderAuthBearerToken } from "utils/requests/auth";
import { webApi } from "services/api/config";

export function useQueryGetScholarshipHistory(userId) {
  return useQuery(["useGetScholarshipHistory", userId], async () => {
    const { data } = await webApi.get(
      `api/ScholarshipRecessHistory/${userId}`,
      {
        headers: {
          Authorization: getHeaderAuthBearerToken(),
        },
      }
    );
    return data;
  });
}
